import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	imagesLoaderStyles: {
		display  : "flex",
		flexWrap : "wrap",
		padding  : "2rem",
		gap      : "1rem"
	},
	imageLoaderStyles: {
		width                   : "calc( 33.333% - 6.666px)",
		height                  : "30.6rem",
		borderTopLeftRadius     : props?.topLeftFlag ? "5px" : "",
		borderTopRightRadius    : props?.topRightFlag ? "5px" : "",
		borderBottomLeftRadius  : props?.bottomLeftFlag ? "5px" : "",
		borderBottomRightRadius : props?.bottomRightFlag ? "5px" : ""
	}
} ) );
